export type PageSection =
  | 'home'
  | 'catalog'
  | 'apis'
  | 'docs'
  | 'tech_radar'
  | 'analytics'
  | 'ai_marketplace'
  | 'architecture'
  | 'security_insights'
  | 'teams'
  | 'preview'
  | 'fleet_census'
  | 'tech_summary'
  | 'scorecard_leaderboard'
  | 'code_migrations'
  | 'agent_launch_platform'
  | 'external_down_detector'
  | 'finops'
  | 'mcp_chat'
  | 'slack_nudges'
  | 'settings'
  | 'search'
  | 'unknown';

export function getPageSection(
  pathname: string,
  search: string = '',
): PageSection {
  // exact home
  if (pathname === '/' || pathname === '') return 'home';
  // group/teams detection before generic catalog
  // The kind=group filter lives in the query string (decoded or percent-encoded).
  if (
    pathname.startsWith('/catalog') &&
    (search.includes('filters%5Bkind%5D=group') ||
      search.includes('filters[kind]=group'))
  )
    return 'teams';
  if (
    pathname.startsWith('/catalog/default/group/') ||
    pathname.startsWith('/groups')
  )
    return 'teams';
  if (pathname.startsWith('/catalog')) return 'catalog';
  if (pathname.startsWith('/api-docs')) return 'apis';
  if (pathname.startsWith('/docs')) return 'docs';
  if (pathname.startsWith('/aoe-radar')) return 'tech_radar';
  if (pathname.startsWith('/analytics')) return 'analytics';
  if (pathname.startsWith('/ai-marketplace')) return 'ai_marketplace';
  if (pathname.startsWith('/architecture')) return 'architecture';
  if (pathname.startsWith('/security-insights')) return 'security_insights';
  if (pathname.startsWith('/preview')) return 'preview';
  if (pathname.startsWith('/fleet-census')) return 'fleet_census';
  if (pathname.startsWith('/tech-summary')) return 'tech_summary';
  if (pathname.startsWith('/scorecard-leaderboard'))
    return 'scorecard_leaderboard';
  if (pathname.startsWith('/code-migrations')) return 'code_migrations';
  if (pathname.startsWith('/arrive-agent-launch-platform'))
    return 'agent_launch_platform';
  if (pathname.startsWith('/external-down-detector'))
    return 'external_down_detector';
  if (pathname.startsWith('/finops')) return 'finops';
  if (pathname.startsWith('/mcp-chat')) return 'mcp_chat';
  if (pathname.startsWith('/slack-nudges')) return 'slack_nudges';
  if (pathname.startsWith('/settings')) return 'settings';
  if (pathname.startsWith('/search')) return 'search';
  return 'unknown';
}
